export default "__VITE_ASSET__D4wQhq3Q__"